<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'
import ABaseInput from '~/components/atoms/forms/BaseInput.vue'
import { InputType } from '~/static/enums/components/base-input'
import { closeModal } from '~/utils/Modal'

interface Props {
  oldName: string
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'edit', name: string): void
}>()

const name = ref(props.oldName)
const error = ref('')

const changeName = (value: string) => {
  name.value = value
}
const edit = () => {
  if (name.value.length === 0) {
    error.value = 'Укажите название'
    return
  }
  emit('edit', name.value)
  closeModal()
}
const cancel = () => {
  closeModal()
}

</script>

<template>
  <RModal
    ref="refModal"
    name-modal="nameChangeModal"
    @close="cancel"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="nameChangeModalLabel"
      >
        Папка «{{ oldName }}»
      </h5>
    </template>

    <template #body>
      <div class="body">
        <span class="d-block mb-2">Новое название</span>
        <ABaseInput
          placeholder="Без названия"
          class="mb-lg-5"
          :value="name"
          :type="InputType.Text"
          :error-message="error"
          @change="changeName"
          @input="changeName"
          @enter="edit"
        />
      </div>
    </template>
    <template #footer>
      <AButton
        :button-style="ButtonStyle.Primary"
        @click="edit"
      >
        Переименовать
      </AButton>
    </template>
  </RModal>
</template>

<style lang="scss" scoped>
.body {
  width: 100%;
}
</style>
